// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Movement_pageWrapper__ig9eJ","tabParent":"Movement_tabParent__cGDUk","active":"Movement_active__QV+IJ"};